module.exports = __webpack_public_path__ + "img/taiyo2s.adc9bf49.gif";